module.exports = __webpack_public_path__ + "img/card1.a049f861.png";